import { Intervention } from '@/app/components/action-plan/types';
import useAnalyticsCalls from '@/hooks/use-analytics';
import useLoadMoreSources from '@/hooks/use-load-more-sources';
import { formatCancerAndOthersNameText, formatCancerAndOthersRiskNameText, getInterventionHighestRisk } from '@/utils';
import { useEffect } from 'react';

export const useModalInterventionDetailsController = (intervention: Intervention, isOpen: boolean) => {
  const {
    title,
    whyItMattersFullExplanation,
    riskImpactDescription,
    riskImpact,
    sources,
    isNonQuantifiable,
    howToAccomplish,
    id,
  } = intervention;

  const cancersAffected = riskImpact.filter(({ cancerType }) => cancerType !== 'overall');
  const overallRisk = riskImpact.reverse().find(({ cancerType }) => cancerType === 'overall');
  const riskImpactList =
    cancersAffected.length > 0 ? cancersAffected.sort((a, b) => b.impact - a.impact) : overallRisk ? [overallRisk] : [];

  const { reducedRisk, otherCancers } = getInterventionHighestRisk(intervention.riskImpact);

  const { visibleSources, showLoadMoreButton, handleLoadMoreSources } = useLoadMoreSources(isOpen, sources);

  const { callActionPlanInterventionViewed } = useAnalyticsCalls();

  useEffect(() => {
    if (isOpen && id) callActionPlanInterventionViewed(title, id);
  }, [title, id, isOpen]);

  const headerText = formatCancerAndOthersNameText({ reducedRisk, isNonQuantifiable, otherCancers });
  const riskText = formatCancerAndOthersRiskNameText({ reducedRisk, cancersAffected, otherCancers });

  return {
    title,
    whyItMattersFullExplanation,
    riskImpactDescription,
    riskImpact,
    sources,
    isNonQuantifiable,
    howToAccomplish,
    cancersAffected,
    riskImpactList,
    reducedRisk,
    visibleSources,
    showLoadMoreButton,
    handleLoadMoreSources,
    headerText,
    riskText,
  };
};
